import { render, staticRenderFns } from "./AppVersioninfo.vue?vue&type=template&id=ce863a70&"
import script from "./AppVersioninfo.vue?vue&type=script&lang=js&"
export * from "./AppVersioninfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports